<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :isPrint="isPrint || !!postId"
                         @selectField="handleSelectField"/>

    <!-- 산업안전보건관리비 -->
    <div>
      <vs-row class="my-4">
        <vs-col><h5><i class="dot"></i>산업안전보건관리비</h5></vs-col>
      </vs-row>
      <vs-row class="mb-8">
        <vs-col>

          <table class="mb-4 table-wrap">
            <tr>
              <th class="p-4 th-cell" rowspan="2" width="100px">편성기준</th>
              <th class="p-4 th-cell" rowspan="2">항목</th>
              <th class="p-4 th-cell" colspan="4">예산</th>
              <th class="p-4 th-cell" rowspan="2" width="100px">지출액</th>
              <th class="p-4 th-cell" rowspan="2" width="100px">지출잔액</th>
              <th class="p-4 th-cell" rowspan="2" width="100px">집행률</th>
            </tr>
            <tr>
              <th class="p-4 th-cell" width="100px">편성액</th>
              <th class="p-4 th-cell" width="100px">본예산</th>
              <th class="p-4 th-cell" width="100px">추경예산</th>
              <th class="p-4 th-cell" width="100px">결산추경</th>
            </tr>

<!--            데이터-->
            <tbody>
            <template v-for="(groupItems, groupName) in groupedData">
              <tr v-for="(item, index) in groupItems" :key="`group-${groupName}item-${index}`">
<!--                편성기준-->
                <template v-if="index === 0">
                  <td :rowspan="getGroupRowCount(groupName)" class="td-cell cell-head">{{ groupName }}</td>
                </template>
<!--                항목-->
                <td class="p-1 td-cell cell-head text-center">{{ item.label }}</td>
<!--                편성액-->
                <td class="p-2 td-cell text-center">
                  <div class="print-input text-right" >{{ comma(budget(item.value1, item.value2, item.value3)) }}</div>
                </td>
                <td class="p-2 td-cell text-center">
                  <div v-if="isPrint" class="print-input text-right" >{{ item.value1 }}</div>
                  <ml-input v-else class="w-full" type="number" v-model="item.value1" :readonly="board.readonly" />
                </td>
                <td class="p-1 td-cell text-center">
                  <div v-if="isPrint" class="print-input text-right" >{{ item.value2 }}</div>
                  <ml-input v-else class="w-full" type="number" v-model="item.value2" :readonly="board.readonly" />
                </td>
                <td class="p-1 td-cell text-center">
                  <div v-if="isPrint" class="print-input text-right" >{{ item.value3 }}</div>
                  <ml-input v-else class="w-full" type="number" v-model="item.value3" :readonly="board.readonly" />
                </td>
                <td class="p-1 td-cell text-center">
                  <div v-if="isPrint" class="print-input text-right" >{{ item.value4 }}</div>
                  <ml-input v-else class="w-full" type="number" v-model="item.value4" :readonly="board.readonly" />
                </td>
<!--                지출잔액-->
                <td class="p-2 td-cell text-center">
                  <div class="print-input text-right" >{{ comma(balance(item.value1, item.value2, item.value3, item.value4)) }}</div>
                </td>
                <td class="p-1 td-cell text-center">
                  <div class="print-input text-right" >{{ rate(item.value1, item.value2, item.value3, item.value4).toFixed(6) }}</div>
                </td>
              </tr>
            </template>
            </tbody>

            <tr>
              <th class="p-4 th-cell" colspan="2">계</th>
              <template v-for="index in 7">
                <td class="p-2 td-cell text-center">
                  <div class="print-input text-right" >{{ calculateA(index - 1) }}</div>
                </td>
              </template>
            </tr>
          </table>
        </vs-col>
      </vs-row>
    </div>
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'


export default {
  components: {
    FieldSelectModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FileUploadModule
  },
  props: {
    tab: Object,
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  computed: {
    myInfo() {
      return this.$store.state.auth.userInfo
    },
    totalInputB() {
      return this.computeInputTotal(this.form.inputB)
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
    groupedData() {
      const groupedData = {};
      this.form.inputA.forEach(item => {
        if (!groupedData[item.group]) {
          groupedData[item.group] = [];
        }
        groupedData[item.group].push(item);
      });
      return groupedData;
    },
  },
  watch: {
    header: {
      immediate: true,
      deep: true,
      handler(/*header*/) {
      }
    },
    value: {
      deep: true,
      async handler(value) {
        // form 과 같은 데이터 인지 체크
        if (JSON.stringify(value) !== JSON.stringify(this.form)) {
          const keys = Object.keys(this.form)
          for (const key of keys) {
            if (value[key]) {
              this.form[key] = value[key]
            }
          }

        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {

        // value.summary = {
        //   안전보건예산_사업장명: [],
        //   안전보건예산_항목명: []
        // }
        //
        // let totalBudget = 0
        // for (const data of this.form.inputB) {
        //   totalBudget += Number(this.removeComma(`${data.value1}`))
        //   value.summary['안전보건예산_항목명'].push({
        //     [data.label]: Number(this.removeComma(`${data.value1}`))
        //   })
        // }
        //
        // value.summary['안전보건예산_사업장명'].push({
        //   [this.form.stdInfo.field_name]: totalBudget
        // })
        //
        this.$emit('input', value)
      }
    },

    EnableSave: {
      immediate: true,
      handler() {
        this.$emit("EnableSave", this.EnableSave)
      }
    },
  },
  data() {
    return {
      EnableSave: true,
      oldForm: {},
      form: {
        total: {},
        stdInfo: {},
        fileList: [],

        budget: 0,
        balance: 0,
        inputA: [
          {group: '인건비', label: '전담인력', value1: 0, value2: 0, value3: 0, value4: 0},
          {group: '인건비', label: '기간제 근로자', value1: 0, value2: 0, value3: 0, value4: 0},
          {group: '인건비', label: '공무직근로자', value1: 0, value2: 0, value3: 0, value4: 0},
          {group: '유해 위험 요인 개선', label: '위험성평가 용역비', value1: 0, value2: 0, value3: 0, value4: 0},
          {group: '유해 위험 요인 개선', label: '근골격계유해요인조사용역비', value1: 0, value2: 0, value3: 0, value4: 0},
          {group: '유해 위험 요인 개선', label: '작업환경측정용역비', value1: 0, value2: 0, value3: 0, value4: 0},
          {group: '유해 위험 요인 개선', label: '안전보건진단, 위탁 및 컨설팅비용', value1: 0, value2: 0, value3: 0, value4: 0},
          {group: '유해 위험 요인 개선', label: '설비 및 시설물에 대한 안전점검비용', value1: 0, value2: 0, value3: 0, value4: 0},
          {group: '중대 재해 예방 활동 및 교육', label: '안전보건교육비', value1: 0, value2: 0, value3: 0, value4: 0},
          {group: '중대 재해 예방 활동 및 교육', label: '안전보건관리 위탁수수료', value1: 0, value2: 0, value3: 0, value4: 0},
          {group: '중대 재해 예방 활동 및 교육', label: '안전보건포상비용', value1: 0, value2: 0, value3: 0, value4: 0},
          {group: '중대 재해 예방 활동 및 교육', label: '안전관련 설명서및 매뉴얼제작', value1: 0, value2: 0, value3: 0, value4: 0},
          {group: '중대 재해 예방 활동 및 교육', label: '안전관련 홍보물 제작', value1: 0, value2: 0, value3: 0, value4: 0},
          {group: '중대 재해 예방 활동 및 교육', label: '중대재해예방 캠페인', value1: 0, value2: 0, value3: 0, value4: 0},
          {group: '근로자 안전보건 관리', label: '안전보건관리 물품및 장비구입', value1: 0, value2: 0, value3: 0, value4: 0},
          {group: '근로자 안전보건 관리', label: '특수건강검진', value1: 0, value2: 0, value3: 0, value4: 0},
          {group: '근로자 안전보건 관리', label: '건강관리실 운영비', value1: 0, value2: 0, value3: 0, value4: 0},
          {group: '기타', label: '그외 안전보건예산', value1: 0, value2: 0, value3: 0, value4: 0},
        ]
      }
    }
  },
  mounted() {
  },
  methods: {
    getGroupRowCount(groupName) {
      const groupItems = this.groupedData[groupName];
      return groupItems ? groupItems.length : 0;
    },
    // 편성액
    budget(a, b, c) {
        let value = Number(a) + Number(b) + Number(c)
        return value
    },
    // 지출잔액
    balance(a, b, c, d) {
      let value = Number(a) + Number(b) + Number(c) - Number(d)
      return value
    },
    // 집행률
    rate(a, b, c, d) {
      const sum = Number(a) + Number(b) + Number(c);
      let value = 0;
      if (sum !== 0) {
        value = Number(d) / sum;
      }
      return value
    },
    // 계
    calculateA(type) {
      let sum0 = 0
      let sum1 = 0
      let sum2 = 0
      let sum3 = 0
      let sum4 = 0
      let sum5 = 0
      let sum6 = 0

      for (const inputA of this.form.inputA) {
        sum0 += Number(this.budget(inputA.value1, inputA.value2, inputA.value3))
        sum1 += Number(inputA.value1)
        sum2 += Number(inputA.value2)
        sum3 += Number(inputA.value3)
        sum4 += Number(inputA.value4)
        sum5 += Number(this.balance(inputA.value1, inputA.value2, inputA.value3, inputA.value4))
        sum6 += Number(this.rate(inputA.value1, inputA.value2, inputA.value3, inputA.value4))
      }

      this.form.budget = sum0
      this.form.balance = sum5

      if (type === 0) return this.comma(sum0)
      else if (type === 1) return this.comma(sum1)
      else if (type === 2) return this.comma(sum2)
      else if (type === 3) return this.comma(sum3)
      else if (type === 4) return this.comma(sum4)
      else if (type === 5) return this.comma(sum5)
      else if (type === 6) return sum6.toFixed(6)
    },



    handleSelectField() {
      this.initTotalB()
    },
    async loadListBoard() {
      const projectId = this.$route.params.proj_id
      const boardId = 106
      const page = 1
      const perPage = 1000
      const dateTarget = 'content$header.full'
      const dateBegin = `${new Date().getFullYear()}-01-01`
      const dateEnd = `${new Date().getFullYear()}-12-31`
      const keyword = [`content$body.stdInfo.field_id*${this.form.stdInfo.field_id}`];

      await this.$store.dispatch('board/LOAD_POST_LIST', {
        boardId,
        projectId,
        page,
        perPage,
        keyword,
        dateTarget,
        dateBegin,
        dateEnd
      })
      const rows = [...JSON.parse(JSON.stringify(this.$store.state.board.list))]
      const totalB = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

      if (rows.length > 0) {
        for (const data of rows) {
          const header = this.getHeader(data)
          const content = this.getContent(data)
          data.header = header;
          data.content = content;
          delete data.post_content;
        }

        // 검색된 데이터를, header.full 오름차순으로 정렬한다
        const sortedRows = rows.sort(function (a, b) {
          const x = new Date(a.header.full).getTime();
          const y = new Date(b.header.full).getTime();

          if (x < y) return -1;
          if (x > y) return 1;
          return 0;
        })

        // 작성된 글 중에서, 선택된 날짜와 가장 가까운 과거의 데이터를 추출한다
        let lastData;
        // 작성되 글 중에서, 선택된 날짜와 동일한 데이터를 추출한다
        let equalData;
        for (const data of sortedRows) {
          if (new Date(data.header.full).getTime() < new Date(this.header.full).getTime()) {
            lastData = data;
          }
          if (new Date(this.header.full).getTime() === new Date(data.header.full).getTime()) {
            equalData = data;
          }
        }

        // 작성된 글 중에서, 가장 마지막 글의 날짜를 확인한다
        const latestDate = sortedRows[sortedRows.length - 1].header.full;
        console.log(1)
        // 만약 현재 작성하는 날짜가, 이미 작성된 글보다 미래가 아닐 경우, 작성할 수 있으면 안된다
        if (new Date(this.header.full).getTime() <= new Date(latestDate).getTime()) {
          this.EnableSave = false;
          console.log(2)
          // 만약 해당 날짜에 작성된 데이터가 있다면, 해당 데이터를 화면에 표시한다
          if (equalData) {
            for (let i = 0; i < equalData.content.inputB.length; i++) {
              this.form.inputB[i].value1 = Number(this.removeComma(equalData.content.inputB[i].value1));
              this.form.inputB[i].value2 = Number(this.removeComma(equalData.content.inputB[i].value2));
              this.form.inputB[i].value3 = Number(this.removeComma(equalData.content.inputB[i].value3));
              this.form.inputB[i].value4 = Number(this.removeComma(equalData.content.inputB[i].value4));

              if (lastData) {
                totalB[i] = Number(this.removeComma(lastData.content.inputB[i].value3));
              } else {
                totalB[i] = 0;
              }
            }
          } else if (lastData) {
            // 만약 해당 날짜에 데이터가 없다면, 가장 최근 과거의 데이터를 화면에 표시한다 (당월 사용 금액은 데이터가 없으므로 0)
            for (let i = 0; i < lastData.content.inputB.length; i++) {
              this.form.inputB[i].value1 = Number(this.removeComma(lastData.content.inputB[i].value1));
              this.form.inputB[i].value2 = Number(this.removeComma(lastData.content.inputB[i].value2));
              this.form.inputB[i].value3 = Number(this.removeComma(lastData.content.inputB[i].value3));
              this.form.inputB[i].value4 = Number(this.removeComma(lastData.content.inputB[i].value4));
              totalB[i] = 0;
            }
          } else {
            for (let i = 0; i < this.form.inputB.length; i++) {
              this.form.inputB[i].value1 = 0;
              this.form.inputB[i].value2 = 0;
              this.form.inputB[i].value3 = 0;
              this.form.inputB[i].value4 = 0;
              totalB[i] = 0;
            }
          }
        } else {
          // 만약 새로운 날짜에 대한 데이터를 입력할 경우, 가장 최근 과거의 데이터를 화면에 표시한다
          this.EnableSave = true;

          if (lastData) {
            for (let i = 0; i < lastData.content.inputB.length; i++) {
              const inputB = lastData.content.inputB[i]
              this.form.inputB[i].value1 = Number(this.removeComma(lastData.content.inputB[i].value1));
              this.form.inputB[i].value2 = 0;
              totalB[i] = Number(this.removeComma(inputB.value3))
            }
          }
        }
        this.form.totalB = totalB
      } else {
        this.EnableSave = true;
      }

      if (!this.form.stdInfo.field_id) {
        this.EnableSave = false;
      }
    },
    getContent(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content)
        return content.body
      }
    },
    getHeader(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content)
        return content.header
      }
    },

    comma(str) {
      return `${str}`.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    removeComma(str) {
      if (str) {
        const noneComma = `${str}`.replaceAll(',', '')
        return `${Number(noneComma)}`
      }
      return '0'
    }
  },
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
.table-wrap {
  width: 100%;
  border-spacing: 0;
  border-top: 1px solid #cdcdcd;
  border-left: 1px solid #cdcdcd;
}

.th-cell {
  white-space: nowrap;
  border-right: 1px solid #cdcdcd;
  border-bottom: 1px solid #cdcdcd;
  background-color: #f9f9f9;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
}
//
//.th-cell:nth-child(1) {
//  max-width: 130px;
//  width: 130px;
//}
//
//.th-cell:nth-child(2) {
//  max-width: 390px;
//  width: 390px;
//}

.td-cell {
  font-weight: 500;
  white-space: nowrap;
  border-right: 1px solid #cdcdcd;
  border-bottom: 1px solid #cdcdcd;
  height: 50px;
}
//.td-cell:nth-child(1) {
//  text-align: center;
//}
.cell-head {
  text-align: center;
  background-color: #f9f9f9;
}
.input-small {
  width: 95px;
}
</style>
